import Modal from '../../Unknown/Modal'
import { useAppDispatch, useAppSelector } from '../../../modules/store/hooks'
import { modalsSlice } from '../../../modules/store/reducers/modalsSlice'
import { Box, Button, TextField } from '@mui/material'
import translate from '../../../i18n/translate'
import { useIntl } from 'react-intl'
import { ReactElement, useState } from 'react'

type TransactionActionModalProps = {
  transactionId: number;
  label: ReactElement;
  onSubmit: (
    id: number,
    text?: string | null,
  ) => Promise<void>;
  buttonText: ReactElement;
}

export default function TransactionActionModal({
  transactionId,
  label,
  buttonText,
  onSubmit,
}: TransactionActionModalProps) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const { toggleTransactionActionModal } = modalsSlice.actions
  const visible = useAppSelector(state => state.modalsReducer.transactionAction)
  const [note, setNote] = useState<string | null>(null);

  const handleSubmit = async () => {
    try {
      await onSubmit(transactionId, note)
      dispatch(toggleTransactionActionModal())
    } catch (error) {
    }
  }

  const onCloseModal = () => {
    dispatch(toggleTransactionActionModal())
  }

  return (
    <Modal
      title={label}
      visible={visible === 'open'}
      style={{ maxWidth: '500px' }}
      setVisible={onCloseModal}
    >
      <Box
        my={2}
        p={2}
        display='flex'
        flexDirection='column'
        justifyContent='center'
        width={1}
        alignItems='center'
        gap={2}
      >
        <TextField 
          variant='outlined'
          color='warning'
          multiline
          rows={4}
          fullWidth
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={intl.formatMessage({ id: "adminNotePlaceholder" })}
          dir="ltr"
          sx={{
            '.MuiInputBase-root.MuiInput-root:before':{
              borderBottom: "0px"
            },
            '.MuiInputBase-root.MuiInput-root:hover':{
              borderBottom: "0px"
            },
          }}
        />
        <Box
          mt={2}
          display='flex'
          flexDirection='column'
          justifyContent='center'
          width={1}
          alignItems='center'
          gap={1}
        >
          <Button
            size='large'
            variant='outlined'
            color='warning'
            fullWidth
            onClick={onCloseModal}
          >
            {translate('cancel')}
          </Button>
          <Button
            size='large'
            variant='contained'
            color='warning'
            fullWidth
            onClick={handleSubmit}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
